import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import "./informes.scss"
import {Button, List} from "antd";
import {history} from "../../../_helpers";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {ShareAltOutlined} from "@ant-design/icons";
import {useLocation} from "react-router-dom";
import {xcService} from "../../../_services/xcService";
import InformeCeibaPDF from "./ceiba.pdf.page"

import CardStudent from "./cardStudent";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const _ = require("lodash");

function InformeCeiba(props) {

    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {query, search} = useLocation();
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [answers, setAnswers] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentProfile, setStudentProfile] = useState(null);
    const [studentArea, setStudentArea] = useState();
    const [studentAreaCervo, setStudentAreaCervo] = useState();
    const [questionnaires, setQuestionnaires] = useState([]);
    const [userQuest, setUserQuest] = useState();
    const [code, setCode] = useState();
    const [course, setCourse] = useState();
    const [answersNoGame3, setAnswersNoGame3] = useState(null);
    const [answersCervo, setAnswersCervo] = useState(null);
    const [answersTek, setAnswersTek] = useState(null);
    const [allLoaded, setAllLoaded] = useState(false)
    const year = +new URLSearchParams(search).get('year');

    const setQuest = (course) => {
        const quests = {
            '3º ESO': 'itin1',
            '4º ESO': 'itin2',
            '1º Bachillerato': 'itin3',
            '2º Bachillerato': 'itin4',
            'FP Grado Básico': 'itin2',
            'FP Grado Medio': 'itin4',
        }
        setUserQuest(quests[course])
    }

    const codes = {
        '3º ESO': 'TEK3ESO',
        '4º ESO': 'TEK4ESO',
        '1º Bachillerato': 'TEK1BAC',
        '2º Bachillerato': 'TEK2BAC',
        'FP Grado Básico': 'TEKFPB',
        'FP Grado Medio': 'TEKFPM',
    }

    const items1 = {
        '3º ESO': 4,
        '4º ESO': year < 23 ? 6 : 7,
        '1º Bachillerato': 7,
        '2º Bachillerato': 7,
        'FP Grado Básico': 5,
        'FP Grado Medio': 5,
    }

    const items2 = {
        '3º ESO': year < 23 ? 14 : 15,
        '4º ESO': year < 23 ? 13 : 14,
        '1º Bachillerato': 12,
        '2º Bachillerato': 10,
        'FP Grado Básico': 11,
        'FP Grado Medio': 10,
    }
    const items3 = {
        '3º ESO': 8,
        '4º ESO': year < 23 ? 7 : 8,
        '1º Bachillerato': 10,
        '2º Bachillerato': 8,
        'FP Grado Básico': 6,
        'FP Grado Medio': 8,
    }
    var getStudentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);

    useEffect(() => {

        const mUrl = userType === 'STUDENT' ? `/v1/student/course?year=${year}` : `/v1/student/course/${studentUid}?year=${year}`;

        xcService.getToken(mUrl)
            .then(({data}) => {
                setQuest(data.data.name)
                setCourse(data.data.name)
                return data.data.name
            }).then(course => {

                setCode(codes[course])
            }
        );
    }, [])

    const [studentHistory, setStudentHistory] = useState();


    const getHistory = () => {
        if (studentUid){

            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => {
                    setStudentHistory(data.data)
                    let mStudentProfile = studentProfile;
                    if (mStudentProfile && data.data.course) {
                        mStudentProfile.course.id = data.data.course.id;
                        mStudentProfile.course.name = data.data.course.name;
                        setStudentProfile(mStudentProfile);
                    }
                })

        }
    }

    useEffect(() => {
        if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
            .then(({data}) =>{
                setStudentProfile(data.data)
                getHistory(studentUid)
            } )
        else {
            //setStudentProfile(localOrSessionStore({key: variables.USER}))

            xcService.getToken('/v1/me').then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            });

        }

    }, [studentUid]);

    const getAllAnsers = async () => {
        const questionPath = userType === 'STUDENT' ? `/v1/student/myquestionnaires?year=${year}` : `/v1/student/${studentUid}/questionnaires?year=${year}`;
        xcService.getToken(questionPath).then(async ({data}) => {

            setQuestionnaires(data.data)
            let mNoGame3 = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM3';
                }
            );
            if (mNoGame3 && mNoGame3[0] && mNoGame3[0].totresp === mNoGame3[0].tota) {
                const mUrl = userType === 'STUDENT' ? `/v1/student/answers/NOGAM3?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM3?withResponses=true&year=${year}`;
                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame3(data.data));

            }

            let mCervo = _.filter(
                data.data, function (o) {
                    return o.code === 'CERVO';
                }
            );
            if (mCervo && mCervo[0] && mCervo[0].totresp === mCervo[0].tota) {
                const mUrl = userType === 'STUDENT' ? `/v1/student/answers/CERVO?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/CERVO?withResponses=true&year=${year}`;

                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersCervo(data.data));
            }

            let mTek = _.filter(
                data.data, function (o) {
                    return o.code === code;
                }
            );
            //if (mTek && mTek[0] && mTek[0].totresp === mTek[0].tota) {
                const mUrl = userType === 'STUDENT' ? `/v1/student/answers/${code}?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/${code}?withResponses=true&year=${year}`;


                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersTek(data.data));
            //}


            const answersPath = userType === 'STUDENT' ? `/v1/student/answers/CEIBA?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/CEIBA?withResponses=true&year=${year}`;
            await xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));

            const areaPath = userType === 'STUDENT' ? `/v1/student/area/CEIBA?year=${year}` : `/v1/student/${studentUid}/area/CEIBA?year=${year}`
            await xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));

            const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
            await xcService.getToken(areaCevoPath).then(({data}) => setStudentAreaCervo(data.data));

            setAllLoaded(true);

        })

    }

    useEffect(() => {
        if (!userType) return;
        getAllAnsers()


    }, [userType, code]);


    const getResponse = (array, code) => {
        let mResult = _.filter(array, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult.length > 0) {

            if (mResult[0].assessment.questionType === "CFGS" && mResult[0].points === 999) {
                return <p dangerouslySetInnerHTML={{__html: t("tek.questionnaire.checkCFGS")}}/>
            }
            if (mResult[0].assessment.questionType === "CFGM" && mResult[0].points === 999) {
                return <p dangerouslySetInnerHTML={{__html: t("tek.questionnaire.checkCFGM")}}/>
            }
            if (mResult[0].assessment.questionType === "UNIV" && mResult[0].points === 999) {
                return <p dangerouslySetInnerHTML={{__html: t("tek.questionnaire.checkuni")}}/>
            }
            if (mResult[0].assessment.questionType === "RATING") {

                return <p>{mResult[0].points}</p>
            } else if (mResult[0].assessment.questionType === "RATINGOB") {

                return <p>{mResult[0].yesno === 1 ? t("yes") + ". " + mResult[0].points : t("no")}</p>
            } else {
                if (mResult[0].response) {
                    return <p>{mResult[0]?.response?.question}</p>
                } else {
                    if (mResult[0].degree) {
                        return <p>{mResult[0]?.degree?.title}</p>
                    }
                    if (mResult[0].subject) {
                        return <p>{mResult[0]?.subject.modality + " - " + mResult[0]?.subject.subject}</p>
                    }
                }
            }
            return "";

        } else {
            return <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.miproyecto")}}/>
        }

    }

    return (!studentProfile || !studentArea ? 'loading' :
            <div className={"container dasboard-informes"}>
                <div className={"gridInformes"}>
                    <div className={"colLeftInformes"}>
                        <h3>{t("informes.title")}</h3>
                        <h4>{t("informes.ceibasubtitle")}</h4>

                        {studentProfile && <CardStudent t={t} studentProfile={studentProfile}  studentHistory={studentHistory} />}

                        <h6>{t("informes.preferente")}</h6>
                        <div className={"cardArea"}>

                            <div className={"img"}>
                                {studentArea &&
                                    <img src={`/assets/img/${studentArea.area.image}`}/>
                                }
                            </div>
                            <div className={"title"}>{studentArea && studentArea.area.name}</div>
                        </div>
                        <p className={"is-desktop changefont"}>{t("informes.comenta")}</p>
                    </div>
                    <div className={"colRightInformes"}>
                        <div className={"colRightInformesTop"}>
                            <div className={"listaAreas"}>
                                <h3>{t("informes.ceibaareasasegun")}</h3>
                                <List
                                    grid={{column: 1}}
                                    header={null}
                                    footer={null}
                                    dataSource={answers.filter(it => it.assessment !== null)}
                                    renderItem={item => (
                                        <List.Item>
                                            <div className={"headerItem headerItemInforme"}>
                                                <>
                                                    {item.points !== 99 ?

                                                        <div style={{
                                                            borderBottomRightRadius: 18,
                                                            borderTopRightRadius: 18,
                                                            minWidth: 192,
                                                            width: `${(item.points === 999 ? 0 : 10 * item.points)}%`
                                                        }}
                                                             className={`txtPoints ${item.points >= 0 && item.points < 5 ? "redBar" :
                                                                 item.points >= 5 && item.points < 8 ? "yellowBar" : item.points === 999 ? "" : "greenBar"
                                                             } informeBarra`}>
                                                            <span>{item.assessment.area.name}</span></div> :
                                                        <div style={{color: "#8C8C8C"}}>{t("indeciso")}</div>
                                                    }
                                                </>
                                                {item.points !== 99 && <span
                                                    className={"pointsInforme"}>{item.points === 999 ? t('indeciso') : item.points}</span>}
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </div>
                            {/*
                        */}
                            <div className={"listaRespuestas"}>
                                <p className={"title"}
                                   dangerouslySetInnerHTML={{__html: t("informes.ceibatusrespuestas")}}/>
                                <div className={"contentCardRespuestas"}>
                                    <div className={"cardRespuesta"}>
                                        <p className={"title"}>{t("informes.respuestas.respuesta1")}</p>


                                        {answersNoGame3 && answersNoGame3.length > 0 ?
                                            getResponse(answersNoGame3, 16)
                                            :
                                            <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.reflexion")}}/>
                                        }


                                    </div>
                                    <div className={"cardRespuesta"}>
                                        <p className={"title"}>{t("informes.respuestas.respuesta2")}</p>
                                        {answersCervo && answersCervo.length  > 0 && studentAreaCervo ?
                                            <p>{studentAreaCervo && studentAreaCervo.area.like}</p>
                                            :
                                            <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.valvocacional")}}/>
                                        }

                                    </div>
                                    <div className={"cardRespuesta"}>
                                        {course === '3º ESO' ?
                                            <p className={"title"}>{t("informes.respuestas.respuesta31")}</p> :
                                            <p className={"title"}>{t("informes.respuestas.respuesta32")}</p>}

                                        {answersTek && answersTek.length > 0 ?
                                            getResponse(answersTek, items1[course])
                                            :
                                            <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.miproyecto")}}/>
                                        }

                                    </div>

                                    <div className={"cardRespuesta"}>
                                        <p className={"title"}>{t("informes.respuestas.respuesta4")}</p>
                                        {answersTek && answersTek.length > 0 ?
                                            getResponse(answersTek, items2[course])
                                            :
                                            <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.miproyecto")}}/>
                                        }

                                    </div>

                                    <div className={"cardRespuesta"}>

                                        {code === 'TEK3ESO' || code === 'TEK4ESO' || code === 'TEKFPB' ?
                                            <p className={"title"}>{t("informes.respuestas.respuesta51")}</p> :
                                            <p className={"title"}>{t("informes.respuestas.respuesta52")}</p>}
                                        {answersTek && answersTek.length > 0 ?
                                            getResponse(answersTek, items3[course])
                                            :
                                            <p dangerouslySetInnerHTML={{__html: t("informes.pendiente.miproyecto")}}/>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className={"is-mobile"}>{t("informes.comenta")}</p>
                        <div className={"colRightInformesBottom"}>
                            {allLoaded && answers && answers.length > 0 && studentArea && studentProfile && studentArea &&
                                <InformeCeibaPDF studentHistory={studentHistory} props={props} studentProfile={studentProfile} forDownload={false}
                                                 answersNoGame3={answersNoGame3}
                                                 answersCervo={answersCervo}
                                                 answersTek={answersTek}
                                                 items1={items1}
                                                 items2={items2}
                                                 items3={items3}
                                                 code={code}
                                                 studentAreaCervo={studentAreaCervo}
                                                 answers={answers}
                                                 course={course}
                                                 studentArea={studentArea}/>
                            }
                            {1 === 2 &&
                            <Button
                                icon={<ShareAltOutlined/>}
                                className="primaryButton">
                                {t("share")}
                            </Button>}
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default withTranslation()(InformeCeiba);


